import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../store/state";
import { AutoGiroPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { Pane, PaneContainer, PaneTitle } from "../../Panes.style";
import { StyledPaneContent } from "./AutogiroPane.style";
import { RadioButtonGroup } from "../../../../../RadioButton/RadioButtonGroup";
import { RoundedBorder } from "../../../shared/Layout/Layout.style";
import { TextWrapper } from "../Bank/BankPane.style";
import { PortableText } from "@portabletext/react";
import { thousandize } from "../../../../../../../../util/formatting";
import LinkButton from "../../../../../EffektButton/LinkButton";
import AnimateHeight from "react-animate-height";
import { API_URL } from "../../../../config/api";
import { usePlausible } from "next-plausible";
import { EffektButton } from "../../../../../EffektButton/EffektButton";
import { calculateDonationBreakdown } from "../../../../utils/donationCalculations";
enum AutoGiroOptions {
  MANUAL_TRANSACTION,
  MANUAL_AUTOGIRO_SETUP,
}

// All new AutoGiro agreements are charged on the 27th of the month
const AUTOGIRO_PAYMENT_DATE = 27;
export const AutogiroPane: React.FC<{
  referrals: WidgetPane3ReferralsProps;
  config: AutoGiroPaymentMethod;
}> = t0 => {
  const $ = _c(107);
  const {
    referrals,
    config
  } = t0;
  const donation = useSelector(_temp);
  const causeAreas = useSelector(_temp2) || [];
  const plausible = usePlausible();
  const [selectedAutogiroSetup, setSelectedAutogiroSetup] = React.useState();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  let t1;
  let t2;
  if ($[0] !== donation.kid) {
    t1 = () => {
      fetch(`${API_URL}/autogiro/${donation.kid}/drafted/paymentdate`, {
        headers: {
          "Content-Type": "application/json"
        },
        method: "PUT",
        body: JSON.stringify({
          paymentDate: AUTOGIRO_PAYMENT_DATE
        })
      });
    };
    t2 = [donation.kid];
    $[0] = donation.kid;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const breakdown = calculateDonationBreakdown(donation.causeAreaAmounts ?? {}, donation.orgAmounts ?? {}, donation.causeAreaDistributionType ?? {}, donation.operationsPercentageModeByCauseArea ?? {}, donation.operationsPercentageByCauseArea ?? {}, causeAreas, donation.selectionType ?? "single", donation.selectedCauseAreaId ?? 1, donation.globalOperationsEnabled ?? false, donation.globalOperationsPercentage ?? 0, donation.operationsConfig?.excludedCauseAreaIds ?? [], donation.operationsConfig?.operationsCauseAreaId, donation.smartDistributionTotal);
  const totalSumIncludingTip = breakdown.totalAmount;
  const T0 = RoundedBorder;
  const T1 = TextWrapper;
  let t3;
  if ($[3] !== config.manual_recurring_option_config.sum_label) {
    t3 = <span>{config.manual_recurring_option_config.sum_label}</span>;
    $[3] = config.manual_recurring_option_config.sum_label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = "autogiro-manual-sum";
  const t5 = thousandize(totalSumIncludingTip || 0);
  let t6;
  if ($[5] !== t5) {
    t6 = <span data-cy={t4}>{t5} kr</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== T1 || $[8] !== t3 || $[9] !== t6) {
    t7 = <T1>{t3}{t6}</T1>;
    $[7] = T1;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== T0 || $[12] !== t7) {
    t8 = <T0>{t7}</T0>;
    $[11] = T0;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== config.manual_recurring_option_config.payer_numberexplanatory_text) {
    t9 = <span>{config.manual_recurring_option_config.payer_numberexplanatory_text}</span>;
    $[14] = config.manual_recurring_option_config.payer_numberexplanatory_text;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== config.manual_recurring_option_config.instruction_text) {
    t10 = <PortableText value={config.manual_recurring_option_config.instruction_text} />;
    $[16] = config.manual_recurring_option_config.instruction_text;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== donation.kid || $[19] !== plausible || $[20] !== setHasSubmitted || $[21] !== totalSumIncludingTip) {
    t11 = () => {
      setHasSubmitted(true);
      if (totalSumIncludingTip) {
        plausible("StartedAgreement", {
          revenue: {
            currency: "SEK",
            amount: totalSumIncludingTip
          },
          props: {
            method: "Autogiro",
            recurring: true,
            kid: donation.kid
          }
        });
      }
    };
    $[18] = donation.kid;
    $[19] = plausible;
    $[20] = setHasSubmitted;
    $[21] = totalSumIncludingTip;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      fontSize: 18,
      marginTop: 10,
      padding: 14
    };
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== config.manual_recurring_option_config.complete_button_text || $[25] !== t11) {
    t13 = <EffektButton onClick={t11} style={t12} data-cy="autogiro-manual-transaction-setup-complete-button">{config.manual_recurring_option_config.complete_button_text}</EffektButton>;
    $[24] = config.manual_recurring_option_config.complete_button_text;
    $[25] = t11;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t8 || $[30] !== t9) {
    t14 = <>{t8}{t9}{t10}{t13}</>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t8;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const manualTransactionContent = t14;
  let t15;
  if ($[32] !== config.recurring_manual_option_config.explanation_text) {
    t15 = <PortableText value={config.recurring_manual_option_config.explanation_text} />;
    $[32] = config.recurring_manual_option_config.explanation_text;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== config.recurring_manual_option_config.date_selector_config.payment_date_format_template) {
    t16 = config.recurring_manual_option_config.date_selector_config.payment_date_format_template.replace("{{date}}", AUTOGIRO_PAYMENT_DATE.toString());
    $[34] = config.recurring_manual_option_config.date_selector_config.payment_date_format_template;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <RoundedBorder data-cy="autogiro-manual-setup-date-wrapper"><TextWrapper data-cy="autogiro-manual-setup-date"><span>{t16}</span></TextWrapper></RoundedBorder>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== donation.kid || $[39] !== plausible || $[40] !== setHasSubmitted || $[41] !== totalSumIncludingTip) {
    t18 = () => {
      setHasSubmitted(true);
      if (totalSumIncludingTip) {
        plausible("StartedAgreement", {
          revenue: {
            currency: "SEK",
            amount: totalSumIncludingTip
          },
          props: {
            method: "Autogiro",
            recurring: true,
            kid: donation.kid
          }
        });
      }
    };
    $[38] = donation.kid;
    $[39] = plausible;
    $[40] = setHasSubmitted;
    $[41] = totalSumIncludingTip;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      fontSize: 18,
      marginTop: 10,
      padding: 14
    };
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== config.recurring_manual_option_config.complete_button_text || $[45] !== t18) {
    t20 = <EffektButton onClick={t18} style={t19} data-cy="autogiro-manual-setup-complete-button">{config.recurring_manual_option_config.complete_button_text}</EffektButton>;
    $[44] = config.recurring_manual_option_config.complete_button_text;
    $[45] = t18;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t15 || $[48] !== t17 || $[49] !== t20) {
    t21 = <>{t15}{t17}{t20}</>;
    $[47] = t15;
    $[48] = t17;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  const manualAutogiroSetupContent = t21;
  let t22;
  if ($[51] !== config.title) {
    t22 = <PaneTitle>{config.title}</PaneTitle>;
    $[51] = config.title;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const t23 = hasSubmitted ? 0 : "auto";
  let t24;
  if ($[53] !== config.payer_number_label) {
    t24 = <span>{config.payer_number_label}</span>;
    $[53] = config.payer_number_label;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== donation.kid) {
    t25 = <span data-cy="autogiro-kid">{donation.kid}</span>;
    $[55] = donation.kid;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t24 || $[58] !== t25) {
    t26 = <RoundedBorder><TextWrapper>{t24}{t25}</TextWrapper></RoundedBorder>;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== config.account_number_label) {
    t27 = <span>{config.account_number_label}</span>;
    $[60] = config.account_number_label;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== config.account_number) {
    t28 = <span data-cy="autogiro-manual-bank-account">{config.account_number}</span>;
    $[62] = config.account_number;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t27 || $[65] !== t28) {
    t29 = <RoundedBorder><TextWrapper>{t27}{t28}</TextWrapper></RoundedBorder>;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  let t31;
  let t32;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <i>Välj ett av nedan alternativ:</i>;
    t31 = <br />;
    t32 = <br />;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
  } else {
    t30 = $[67];
    t31 = $[68];
    t32 = $[69];
  }
  let t33;
  if ($[70] !== config.recurring_manual_option_config.title || $[71] !== manualAutogiroSetupContent) {
    t33 = {
      title: config.recurring_manual_option_config.title,
      value: AutoGiroOptions.MANUAL_AUTOGIRO_SETUP,
      content: manualAutogiroSetupContent,
      data_cy: "autogiro-radio-manual-autogiro-setup"
    };
    $[70] = config.recurring_manual_option_config.title;
    $[71] = manualAutogiroSetupContent;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== config.manual_recurring_option_config.title || $[74] !== manualTransactionContent) {
    t34 = {
      title: config.manual_recurring_option_config.title,
      value: AutoGiroOptions.MANUAL_TRANSACTION,
      content: manualTransactionContent,
      data_cy: "autogiro-radio-manual-transaction"
    };
    $[73] = config.manual_recurring_option_config.title;
    $[74] = manualTransactionContent;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== t33 || $[77] !== t34) {
    t35 = [t33, t34];
    $[76] = t33;
    $[77] = t34;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== plausible || $[80] !== setSelectedAutogiroSetup) {
    t36 = selected => {
      plausible("AutogiroMethodeSelected" + selected);
      setSelectedAutogiroSetup(selected);
    };
    $[79] = plausible;
    $[80] = setSelectedAutogiroSetup;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== selectedAutogiroSetup || $[83] !== t35 || $[84] !== t36) {
    t37 = <RadioButtonGroup options={t35} selected={selectedAutogiroSetup} onSelect={t36} />;
    $[82] = selectedAutogiroSetup;
    $[83] = t35;
    $[84] = t36;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== t23 || $[87] !== t26 || $[88] !== t29 || $[89] !== t37) {
    t38 = <AnimateHeight height={t23} animateOpacity={true}>{t26}{t29}{t30}{t31}{t32}{t37}</AnimateHeight>;
    $[86] = t23;
    $[87] = t26;
    $[88] = t29;
    $[89] = t37;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  const t39 = hasSubmitted ? "auto" : 0;
  let t40;
  if ($[91] !== config.completed_text) {
    t40 = <div data-cy="autogiro-completed-text"><PortableText value={config.completed_text} /></div>;
    $[91] = config.completed_text;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== t39 || $[94] !== t40) {
    t41 = <AnimateHeight height={t39} animateOpacity={true}>{t40}</AnimateHeight>;
    $[93] = t39;
    $[94] = t40;
    $[95] = t41;
  } else {
    t41 = $[95];
  }
  let t42;
  if ($[96] !== t22 || $[97] !== t38 || $[98] !== t41) {
    t42 = <StyledPaneContent>{t22}{t38}{t41}</StyledPaneContent>;
    $[96] = t22;
    $[97] = t38;
    $[98] = t41;
    $[99] = t42;
  } else {
    t42 = $[99];
  }
  let t43;
  if ($[100] !== referrals.other_referral_input_placeholder || $[101] !== referrals.referrals_title || $[102] !== referrals.show_referrals) {
    t43 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[100] = referrals.other_referral_input_placeholder;
    $[101] = referrals.referrals_title;
    $[102] = referrals.show_referrals;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== t42 || $[105] !== t43) {
    t44 = <Pane><PaneContainer>{t42}{t43}</PaneContainer></Pane>;
    $[104] = t42;
    $[105] = t43;
    $[106] = t44;
  } else {
    t44 = $[106];
  }
  return t44;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}